import React from "react";
import Sculp1 from "../../images/home/grid/sculp1.jpg";
import Sculp2 from "../../images/home/grid/sculp2.jpg";
import Sculp3 from "../../images/home/grid/sculp3.jpg";
import Sculp4 from "../../images/home/grid/sculp4.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { MdArrowForward, MdArrowRightAlt } from "react-icons/md";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import Fadeup from "../fadeup/Fadeup";

const auctionData = [
  {
    id: 1,
    title: "Ancient Sculpture",
    content: "A timeless oil painting under dramatic lighting, showcasing intricate brushwork and aged textures, symbolizing the artistic treasures we auction.",
    image: Sculp1,
    price: "$5,000",
    timeLeft: "2h 15m left",
  },
  {
    id: 2,
    title: "Vintage Oil Painting",
    content: "An elegant auctioneer mid-action in a vintage-themed auction hall, with an attentive crowd, encapsulating the excitement and formality of the auction event.",
    image: Sculp2,
    price: "$12,000",
    timeLeft: "1h 45m left",
  },
  {
    id: 3,
    title: "Antique Vase Collection",
    content: "A curated arrangement of antique sculptures and artifacts displayed under soft spotlights, evoking a sense of historical discovery.",
    image: Sculp3,
    price: "$8,500",
    timeLeft: "3h 10m left",
  },
  {
    id: 4,
    title: "Classic Bronze Statue",
    content: "A stylized clock with Roman numerals and digital elements merged together, visually representing the blending of eras that defines our identity.",
    image: Sculp4,
    price: "$6,200",
    timeLeft: "4h 30m left",
  },
];

const AuctionCards = () => {
  const navigate=useNavigate()
  return (
    <section className="sec_pd bg-light mt-5">
      <div className="container">
        <div className="row pt-5">
          {/* Left Side Content */}
          <div className="col-lg-4 col-md-12 col-12 d-flex flex-column justify-content-center">
          <Fadeup delay={0.3}>
            <h3 className="text-left mb-4 mx-3 pb-2 text-black fs_40">
              {/* Live Art & Antiques Auction */}
              Introduction / Mission Statement
            </h3>
            </Fadeup>
            <Fadeup delay={0.2}>
            <p className="text-left mx-3 pb-2 text-black">
              {/* Join our Live Art & Antiques Auction and bid on rare collectibles,
              exquisite artworks, and historic treasures. <br /> Experience the
              excitement of live bidding and own a piece of cultural heritage.
              Don't miss this exclusive opportunity to acquire unique
              masterpieces! */}
              Where Time Meets Treasure<br />
            Anachronistic Auction House is more than a marketplace – it’s a bridge across centuries. We
            bring together art, history, and passionate collectors from around the world. Our mission is to
            curate, preserve, and celebrate the stories embedded in each artifact we present, transforming
            every auction into a journey through time.
            </p>
            
            
            <div>
              <motion.div
                animate={{ x: [0, 20, 0] }} // Moves right then back
                transition={{
                    duration: 1, 
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                >
                <MdArrowRightAlt color="black" size={50} style={{cursor:"pointer"}} onClick={() => navigate('/auction')} />
                </motion.div>
              </div>
              </Fadeup>
          </div>
          {/* Right Side Swiper Slider */}
          <div className="col-lg-8 col-md-12 col-12 ">
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              loop={true}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1200: { slidesPerView: 3 },
              }}
              style={{ paddingBottom: "50px" }}
            >
              {auctionData.map((item) => (
                <SwiperSlide key={item.id}>
                  <div
                    className="card h-100 floral-border d-flex flex-column bg-light align-items-stretch cards_slide"
                    style={{ width: "100%" }}
                  >
                    <img
                      src={item.image}
                      className="card-img-top"
                      width={200}
                      height={200}
                      alt={item.title}
                    />
                    <div className="card-body flex-grow-1 d-flex flex-column">
                      <h5 className="card-title fw-bold">{item.title}</h5>
                      <p className="card-text flex-grow-1">{item.content}</p>
                      {/* <p className="fw-bold text-danger">Current Bid: {item.price}</p>
                      <p className="text-muted">⏳ {item.timeLeft}</p> */}
                      <div className="d-flex justify-content-end">
                      {/* <button className="button_cus text-black w-auto d-flex align-items-center">
                        Place a Bid Now <MdArrowForward className="ms-2" size={20} />
                      </button> */}
                      {/* <Link
                    to='/auction'
                    className="btn signup-btn text-white  position-relative overflow-hidden border-0"
                  >
                    <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                      <p className="m-0 text-black fw-bold button_name">
                        Place Bid
                      </p>
                    </div>
                  </Link> */}
                    </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuctionCards;